export const dashboard = {
    action: "fa fa-home",
    title: "Home",
    permission: "dashboard",
    items: [
        {
            title: "Home",
            prefix: "I",
            link: "/dashboard",
            permission: "",
        },

        {
            title: "DashboardDelivredCamp",
            prefix: "I",
            link: "/delivery-business",
            // permission: "",
            permission: "dashboard-power-bi-1",
        },
        {
            title: "gisDashboard",
            prefix: "I",
            link: "/gis-dashboard",
            permission: "dashboard-gis-1",
        },
        {
            title: "additionsStage",
            prefix: "OS",
            link: "/additions-stage",
            permission: "dashboard-additions-stage",
        },

        {
            title: "DashboardCivilDefense",
            prefix: "OS",
            link: "/civil-defense",
            permission: "dashboard-civil-defense",
        },
        {
            title: "DashboardViolations",
            prefix: "OS",
            link: "/dashboard-report-violations",
            permission: "dashboard-report-violations",
        },
    ],
};